import Physics from "./Physics";
import MathUtil from "../utils/MathUtil";
import Point3D from "../math/Point3D";
import GameSprite from "./GameSprite";

class MotmPhysics extends Physics
{
    constructor()
    {
        super();

        this.lifeTime = 120;
        this.stopMove = false;
        this.reachedLimit = false;
        this.shouldLeave = false;

        this.directionLimitsMin = new PIXI.Point(
                this.app.layout.relWidth(10),
                this.app.layout.relHeight(15)
        );
        this.directionLimitsMax = new PIXI.Point(
                this.app.layout.relWidth(90 + this.app.config.viewPadSize),
                this.app.layout.relHeight(85 + this.app.config.viewPadSize)
        );

        // this.addSpiralModifier(10, Math.PI * 2 - Math.PI/7, 30, 2);
    }


    setSize(size)
    {
        this.endSize = size;
        super.setSize(size);
    }


    // addSpiralModifier(time = 10, startAngle = Math.PI * 2 - Math.PI/7, b = 20, delay = 2)
    // {
    //     this.spiralDelay = delay;
    //     this.spiralDuration = time;
    //     this.startAngle = startAngle;
    //
    //     // controls the distance difference between each successful turn (circle)
    //     this.b = b;
    // }


    addVelocityModifier(omega, modAmplX, modAmplY)
    {
        this.omega = omega;
        this.modAmplX = modAmplX;
        this.modAmplY = modAmplY;
        this.modifiedVelocity = new Point3D(0,0,0);
    }


    // returns true if reaching close to the screen limits
    shouldChangeDirection()
    {
        return this.reachedLimit;
    }


    update(delta)
    {
        if (!this.isSpriteRendered) return;
        if (this.stopMove) return;

        this.timeElapsed += delta;
        this.lifeTime -= delta;


        this.position.x += this.velocity.x * delta;
        this.position.y += this.velocity.y * delta;
        this.position.z += this.velocity.z * delta;

        let s = this.getEntity().getComponent(GameSprite);

        let width;
        let height;
        width = height = s.baseHeight * s.armatureDisplay.scale.x;
        let screenCoordinates = this.app.layout.projectGameToScreen(this.position, this.size);

        if (this.lifeTime > 0)
        {
            this.reachedLimit = false;
            this.toX = this.toY = 0;
            if (screenCoordinates.x < this.directionLimitsMin.x) { this.toX = 10; this.reachedLimit = true}
            if (screenCoordinates.x > this.directionLimitsMax.x) { this.toX = -10; this.reachedLimit = true}
            if (screenCoordinates.y < this.directionLimitsMin.y) { this.toY = 10; this.reachedLimit = true}
            if (screenCoordinates.y > this.directionLimitsMax.y) { this.toY = -10; this.reachedLimit = true}
        }
        else
        {
            this.shouldLeave = true;
            if (screenCoordinates.x < -width ||
                screenCoordinates.x > this.app.layout.relWidth(100 + this.app.config.viewPadSize) + width ||
                screenCoordinates.y < -height ||
                screenCoordinates.y > this.app.layout.relHeight(100 + this.app.config.viewPadSize) + height ||
                this.position.z < 0)
            {
                this.getEntity().queueForRemoval = true;
            }
        }


        // if (this.timeElapsed > this.motherOfMoonLifetime)
        // {
        //     this.getEntity().queueForRemoval = true;
        // }

    }


    // update(delta)
    // {
    //     if (!this.isSpriteRendered) return;
    //
    //     this.timeElapsed += delta;
    //
    //     this.velocity.x += this.acceleration.x * delta;
    //     this.velocity.y += this.acceleration.y * delta;
    //     this.velocity.z += this.acceleration.z * delta;
    //
    //     let theta = (this.startAngle/(this.spiralDuration)) * (this.spiralDuration + this.spiralDelay - this.timeElapsed/4);
    //     // let theta = (this.startAngle);
    //     theta = MathUtil.clamp(theta, 0, this.startAngle);
    //     let R = this.b * theta;
    //
    //     let x = R * Math.cos(theta);
    //     let y = R * Math.sin(theta);
    //
    //     if (this.modifiedVelocity)
    //     {
    //         this.modifiedVelocity.x = this.modAmplX*Math.cos(this.omega/5 * this.timeElapsed);
    //         this.modifiedVelocity.y = this.modAmplY*Math.sin(this.omega * this.timeElapsed);
    //     }
    //
    //     // this.position.x = x + this.modifiedVelocity.x;
    //     // this.position.y = y + this.modifiedVelocity.y;
    //
    //     if (!this.stopMove && this.spiralDelay < this.timeElapsed/4)
    //     {
    //         this.position.z += this.velocity.z * delta;
    //     }
    //     else if (this.spiralDelay > this.timeElapsed/4)
    //     {
    //         // this.size = this.endSize * (0.7 + this.spiralDelay - this.timeElapsed/4)
    //     }
    //
    //     // this.position.x = 0.5*Math.cos(0.2 * this.timeElapsed);
    //     // this.position.y = 0.5*Math.sin(1.5 * this.timeElapsed);
    //
    //     // if (this.posMin && this.posMax)
    //     // {
    //     //     if (this.position.x < this.posMin.x || this.posMax.x < this.position.x ||
    //     //         this.position.y < this.posMin.y || this.posMax.y < this.position.y ||
    //     //         this.position.z < this.posMin.z || (this.posMax.z < this.position.z && this.velocity.z > 0))
    //     //     {
    //     //         this.getEntity().queueForRemoval = true;
    //     //     }
    //     // }
    //
    //     if (this.timeElapsed/4 > this.motherOfMoonLifetime)
    //     {
    //         let s = this.entity.getComponent(GameSprite);
    //         s.playVanishAnimation();
    //     }
    // }
}

export default MotmPhysics;